import React, { useState } from "react";

import { useMsal } from "@azure/msal-react";

import {
  Button,
  Dialog,
  DialogContent,
  Slide,
  TextField,
  Grid,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

import DbUpload from "./FileUpload";
import apiCall from "../utils/apiCall";
import getBase64 from "../utils/getBase64";

import { DATABASE, EXCEL, IMAGE, NEO4J, PDF, YOUTUBE } from "../data/constants";

import { useAppDispatch, useAppSelector } from "../hooks/reduxhook";
import { addFiles, getFiles, getType } from "../redux/slices/typeSlice";
import { loadingforindexes } from "../redux/slices/loadingSlice";
import { addError } from "../redux/slices/errorSlice";
import ConfirmModal from "./ConfirmModal";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface INeo4jConnectionAdd {
  url: string;
  handleClose: any;
}

const Neo4jConnectionAdd = ({ url, handleClose }: INeo4jConnectionAdd) => {
  const { accounts } = useMsal();
  const accountId = accounts[0]?.username;
  const [data, setData] = useState({
    db_name: "",
    username: "",
    password: "",
    url: "",
    cypher: "",
    instructions: "",
  });

  const dispatch = useAppDispatch();

  const uploadDb = () => {
    // if (dbType === "pdf") {
    //   dispatch(startLoading())
    dispatch(loadingforindexes(true));
    apiCall("POST", url, {
      user_email: accountId,
      ...data,
    })
      .then((res) => {
        dispatch(addFiles(res.result));
        handleClose();
      })
      .catch((err) => {
        dispatch(addError("Failed to upload the file.Please try again."));
      })
      .finally(() => {
        dispatch(loadingforindexes(false));
      });
  };

  return (
    <>
      <TextField
        value={data?.db_name}
        onChange={(e) => {
          setData((prevData) => ({ ...prevData, db_name: e.target.value }));
        }}
        label="Database Name"
        variant="outlined"
        // sx={{ mt: 2 }}
        fullWidth
        sx={{
          mt: 2,
          ".MuiFormHelperText-root": {
            color: "rgba(255,0,0,0.5)",
            fontSize: "11px",
          },
        }}
      />

      <TextField
        value={data.url}
        onChange={(e) => {
          setData((prevData) => ({ ...prevData, url: e.target.value }));
        }}
        label="Url"
        variant="outlined"
        // sx={{ mt: 2 }}
        fullWidth
        sx={{
          mt: 2,
          ".MuiFormHelperText-root": {
            color: "rgba(255,0,0,0.5)",
            fontSize: "11px",
          },
        }}
      />

      <TextField
        value={data.username}
        onChange={(e) => {
          setData((prevData) => ({ ...prevData, username: e.target.value }));
        }}
        label="Username"
        variant="outlined"
        // sx={{ mt: 2 }}
        fullWidth
        sx={{
          mt: 2,
          ".MuiFormHelperText-root": {
            color: "rgba(255,0,0,0.5)",
            fontSize: "11px",
          },
        }}
      />
      <TextField
        value={data.password}
        onChange={(e) => {
          setData((prevData) => ({ ...prevData, password: e.target.value }));
        }}
        label="Password"
        variant="outlined"
        // sx={{ mt: 2 }}
        fullWidth
        sx={{
          mt: 2,
          ".MuiFormHelperText-root": {
            color: "rgba(255,0,0,0.5)",
            fontSize: "11px",
          },
        }}
      />

      <TextField
        value={data.cypher}
        onChange={(e) => {
          setData((prevData) => ({ ...prevData, cypher: e.target.value }));
        }}
        label="Cypher"
        variant="outlined"
        // sx={{ mt: 2 }}
        fullWidth
        sx={{
          mt: 2,
          ".MuiFormHelperText-root": {
            color: "rgba(255,0,0,0.5)",
            fontSize: "11px",
          },
        }}
        multiline
        minRows={3}
        maxRows={3}
      />
      <TextField
        value={data.instructions}
        onChange={(e) => {
          setData((prevData) => ({
            ...prevData,
            instructions: e.target.value,
          }));
        }}
        label="Instructions"
        variant="outlined"
        // sx={{ mt: 2 }}
        fullWidth
        sx={{
          mt: 2,
          ".MuiFormHelperText-root": {
            color: "rgba(255,0,0,0.5)",
            fontSize: "11px",
          },
        }}
        multiline
        minRows={5}
        maxRows={5}
      />

      <Button
        variant="contained"
        fullWidth
        sx={{ mt: 4 }}
        disabled={
          data?.db_name.length === 0 ||
          data?.url.length === 0 ||
          data?.username.length === 0 ||
          data?.password.length === 0
        }
        onClick={uploadDb}
        color="primary"
      >
        Add Connection
      </Button>
    </>
  );
};

export default Neo4jConnectionAdd;
